import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/UnderstandingTransformerBushingsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-23.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .utb { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .utb-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .utb-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .utb-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .utb-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .utb-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .utb-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .utb-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .utb-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .utb-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .utb-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .utb-bc-item:hover { color: #EB2019; }
  .utb-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .utb-bc-sep img { width: 24px; height: 24px; display: block; }
  .utb-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .utb-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .utb-main-section { padding: 80px 0 120px 0; }
  .utb-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .utb-article { flex: 1; min-width: 0; }

  .utb-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .utb-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .utb-meta-item:last-child { border-right: none; padding-right: 0; }
  .utb-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .utb-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .utb-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .utb-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .utb-article-body p { margin-bottom: 20px; }
  .utb-article-body p:last-child { margin-bottom: 0; }

  .utb-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  .utb-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 10px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .utb-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .utb-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .utb-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .utb-article-body ul li > span { flex: 1; }

  .utb-article-body strong { font-weight: 600; color: #202020; }

  .utb-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .utb-red-link:hover { opacity: 0.8; }
  .utb-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .utb-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .utb-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .utb-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .utb-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .utb-nav-btn:hover { color: #EB2019; }
  .utb-nav-btn img { width: 40px; height: 40px; display: block; }

  .utb-share-icons { display: flex; align-items: center; gap: 20px; }
  .utb-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .utb-share-icon:hover { opacity: 0.85; }
  .utb-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .utb-sidebar { flex: 0 0 475px; }
  .utb-sidebar-block { margin-bottom: 60px; }
  .utb-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .utb-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .utb-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .utb-recent-item:hover .utb-recent-title { color: #EB2019; }
  .utb-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .utb-recent-body { flex: 1; min-width: 0; }
  .utb-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .utb-social-icons { display: flex; align-items: center; gap: 30px; }
  .utb-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .utb-social-icon:hover { opacity: 0.8; }
  .utb-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .utb-hero             { height: 350px; }
    .utb-hero-content     { padding: 0 32px; }
    .utb-hero-title       { font-size: 30px; }
    .utb-hero-divider     { width: 100%; max-width: 479px; }
    .utb-breadcrumb       { padding: 24px 0 0 0; }
    .utb-breadcrumb-inner { padding: 0 32px; }
    .utb-inner            { padding: 0 32px; }
    .utb-main-section     { padding: 48px 0 60px 0; }
    .utb-main-row         { flex-direction: column; gap: 48px; }
    .utb-sidebar          { flex: none; width: 100%; }
    .utb-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .utb-hero             { height: 360px; }
    .utb-hero-content     { padding: 0 16px; }
    .utb-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .utb-hero-divider     { width: 100%; }
    .utb-hero-subtitle    { font-size: 14px; }
    .utb-breadcrumb       { padding: 30px 0 0 0; }
    .utb-breadcrumb-inner { padding: 0 16px; }
    .utb-bc-item          { font-size: 14px; gap: 14px; }
    .utb-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .utb-bc-sep img       { width: 22px; height: 22px; }
    .utb-inner            { padding: 0 16px; }
    .utb-main-section     { padding: 30px 0 60px 0; }
    .utb-main-row         { flex-direction: column; gap: 60px; }
    .utb-sidebar          { flex: none; width: 100%; }
    .utb-article-title    { font-size: 20px; margin-bottom: 15px; }
    .utb-article-body     { font-size: 14px; }
    .utb-article-body p   { margin-bottom: 15px; }
    .utb-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .utb-article-body ul li { font-size: 14px; }
    .utb-meta-item        { font-size: 14px; }
    .utb-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .utb-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .utb-h3               { font-size: 14px; margin: 15px 0 10px 0; }
    .utb-nav-btn img      { width: 24px; height: 24px; }
    .utb-nav-btn          { font-size: 14px; }
    .utb-share-icon img   { width: 34px; height: 34px; }
    .utb-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function UnderstandingTransformerBushingsTypesFunctions() {
  return (
    <div className="utb">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="utb-hero">
        <img className="utb-hero-bg" src={HeroBgImg} alt="Understanding Transformer Bushings Hero" />
        <div className="utb-hero-overlay" />
        <div className="utb-hero-content">
          <h1 className="utb-hero-title">
            Understanding Transformer Bushings: Types, Functions, and Importance
          </h1>
          <hr className="utb-hero-divider" />
          <p className="utb-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="utb-breadcrumb" aria-label="Breadcrumb">
        <div className="utb-breadcrumb-inner">
          <a href="/" className="utb-bc-item">Home</a>
          <span className="utb-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="utb-bc-item">News &amp; Updates</a>
          <span className="utb-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="utb-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="utb-main-section">
        <div className="utb-inner">
          <div className="utb-main-row">

            {/* ── ARTICLE ── */}
            <article className="utb-article">

              {/* Meta bar */}
              <div className="utb-meta-bar">
                <span className="utb-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="utb-meta-item"><img src={CalendarIcon} alt="date" /> March 5, 2025</span>
                <span className="utb-meta-item"><img src={ClockIconImg} alt="time" /> 11:14 am</span>
                <span className="utb-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="utb-article-title">
                Understanding Transformer Bushings: Types, Functions, and Importance
              </h1>

              {/* Body */}
              <div className="utb-article-body">

                <span className="utb-h2">Understanding Transformer Bushings</span>

                <p><a href="/role-transformer-bushings-safe-power-transmission" className="utb-red-link">Transformer bushings</a> are critical components designed to safely guide electrical conductors through a grounded transformer casing, providing both mechanical support and electrical insulation. Essentially, they allow high-voltage electricity to pass into or out of a transformer without making contact with the grounded enclosure, preventing dangerous faults. Think of them as protective gateways that shield the transformer from electrical stress and environmental conditions. Without properly functioning bushings, there's a heightened risk of short circuits, flashovers, or even severe equipment damage. Available in various types—such as porcelain, resin, or oil-filled—transformer bushings are carefully selected based on voltage levels, operating conditions, and system requirements to ensure safe and reliable power transmission.</p>

                <p><strong>Transformer bushings</strong> are critical in the safe and reliable operation of electrical transformers. They provide an insulated pathway for high-voltage electrical conductors to move through the grounded transformer tank. Without them, transformers could not run reliably or safely.</p>

                <p>In this article, we discuss types of <a href="/transformer-bushings" className="utb-red-link-plain">transformer bushings</a>, their purpose, and their importance to help readers understand power systems.</p>

                {/* Article image */}
                <img className="utb-article-img" src={ArticleImg} alt="Transformer Bushings" />

                <p><strong>There are various types of transformer bushings, each applied to multiple applications.</strong><br />
                The most general types include:</p>

                <span className="utb-h3">1. Oil-impregnated paper (OIP) Bushings</span>
                <ul>
                  <li><span>Made of paper insulation saturated with oil.</span></li>
                  <li><span>They are well-suited for high-voltage applications due to their superior insulation properties.</span></li>
                  <li><span>Used in power transformers and substations.</span></li>
                </ul>

                <span className="utb-h3">2. Resin-impregnated paper (RIP) Bushings</span>
                <ul>
                  <li><span>As in OIP bushings, they use resin instead of oil for insulation.</span></li>
                  <li><span>They are also environmentally friendlier because they exclude the potential for oil leaks.</span></li>
                  <li><span>Provide superior performance and strength in demanding conditions.</span></li>
                </ul>

                <span className="utb-h3">3. Resin-Bonded Paper (RBP) Bushings</span>
                <ul>
                  <li><span>It is manufactured using paper and resin bonding.</span></li>
                  <li><span>Specially designed for medium-voltage.</span></li>
                  <li><span>It is economical but less durable than RIP or OIP bushings.</span></li>
                </ul>

                <span className="utb-h3">4. Ceramic Bushings</span>
                <ul>
                  <li><span>They are constructed of porcelain and commonly applied to low and medium-voltage systems.</span></li>
                  <li><span>They are highly resistant to environmental conditions like moisture and pollutants.</span></li>
                </ul>

                <span className="utb-h3">5. as-insulated Bush</span>
                <ul>
                  <li><span>Use sulfur hexafluoride (SF6) gas for insulation</span></li>
                  <li><span>Ideal for high-voltage, compact designs such as gas-insulated substations.</span></li>
                  <li><span>It is low maintenance and highly reliable.</span></li>
                </ul>

                <p><strong>Transformer bushings serve various significant functions in electrical systems:</strong></p>

                <p><strong>Electrical Insulation –</strong> Prevents electrical failures and offers safe power transmission.</p>

                <p><strong>Structural Support –</strong> It provides a strong and secure interconnection of transformer components.</p>

                <p><strong>Leakage Prevention –</strong> Prevents leaks of oil or gas in transformers, which facilitates proper functioning.</p>

                <p><strong>Voltage Regulation –</strong> It ensures steady voltage levels within the electrical system.</p>

                <span className="utb-h2">Transformer Bushings Significance</span>

                <p>Transformer bushings are of great importance. Here is why:</p>

                <ul>
                  <li><span>Safety First – Proper insulation eliminates dangerous electrical faults and short circuits.</span></li>
                  <li><span>Efficient Operation – Make sure transformers run without power loss or heating.</span></li>
                  <li><span>Long equipment life – It extends equipment life and reduces wear and tear.</span></li>
                  <li><span>Cost Savings – Prevents failures that can lead to repair or replacement costs.</span></li>
                </ul>

                <span className="utb-h2">In Essence</span>

                <p>Transformer bushings are critical in power systems, assuring safety, efficiency, and reliability. Based on voltage levels and environmental circumstances, the right kind of transformer bushing can remarkably enhance the transformer's performance and life.</p>

                <p>Need assistance with transformer components? For high-quality <strong>transformer bushings</strong> and expert advice, contact us today!</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="utb-bottom-row">
                <div className="utb-bottom-nav">
                  <a href="/news/esp-thermal-power-plants-efficiency" className="utb-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/how-to-choose-transformer-bushing-high-voltage" className="utb-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="utb-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/understanding-transformer-bushings-types-functions-and-importance/" className="utb-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Funderstanding-transformer-bushings-types-functions-and-importance%2F&mode=login" className="utb-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Funderstanding-transformer-bushings-types-functions-and-importance%2F%26title%3DTransformer%2520Bushings%2520%25E2%2580%2593%2520Types%2520%2526%2520Importance%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Funderstanding-transformer-bushings-types-functions-and-importance%2F" className="utb-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="utb-sidebar">

              {/* Recent Posts */}
              <div className="utb-sidebar-block">
                <p className="utb-sidebar-title">Recent Posts</p>
                <div className="utb-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="utb-recent-item">
                      <img src={post.img} alt={post.title} className="utb-recent-img" />
                      <div className="utb-recent-body">
                        <span className="utb-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="utb-sidebar-block">
                <p className="utb-sidebar-title">Social Media</p>
                <div className="utb-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="utb-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="utb-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}